var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeliveryTruck = function SvgDeliveryTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M14.308 7.077h4.615A3.077 3.077 0 0 1 22 10.154v6.154h-2.308M3.538 16.308H2V5.538A1.54 1.54 0 0 1 3.538 4h9.231a1.54 1.54 0 0 1 1.539 1.538v8.739M13.538 16.308H9.692"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    d: "M16.616 19.384a3.077 3.077 0 1 1 0-6.154 3.077 3.077 0 0 1 0 6.154M6.615 19.384a3.077 3.077 0 1 1 0-6.154 3.077 3.077 0 0 1 0 6.154"
  })));
};
export default SvgDeliveryTruck;